import { writable } from 'svelte/store';
const isDownloadDialogOpen = writable(false);
export default isDownloadDialogOpen;
